import axios from '../utils/axios'

/**
 * 获取活动列表
 * @param {*} token
 * @param {*} datas
 * @returns
 */
export const getActivityList = (token, datas) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-content/content/front/getActivityOperationDetail';
    axios.defaults.headers.common['Blade-Auth'] = token;
    axios({
      headers:{
        'Content-Type':'application/x-www-form-urlencoded',
      },
      url:url,
      method:"get",
      params:datas
    })
    .then((res)=>{
      resolve(res.data)
    })
    .catch((err)=>{
      reject(err)
    })
  })
}

/**
 * 获取字典 /blade-system/dict/dictionary
 * @param {*} token
 * @param {*} datas
 * @returns
 */
 export const getDictionary = (token, datas) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-system/dict-biz/dictionary';
    axios.defaults.headers.common['Blade-Auth'] = token;
    axios({
      headers:{
        'Content-Type':'application/x-www-form-urlencoded',
      },
      url:url,
      method:"get",
      params:datas
    })
    .then((res)=>{
      resolve(res.data)
    })
    .catch((err)=>{
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/active.js